import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Instalacion } from '../../../../types/Instalacion';
import Accordion from '../../../../components/Accordion';
import Table, {
  ColumnDefinitionType,
} from '../../../../components/Table';
import { Loading } from '../../../../components/Loading';
import { useInstalacion } from '../../../../hooks/useInstalacion';
import { downloadAndOpenQR } from '../../../../services/Service';

export const TablaInstalacion = () => {
  const { instalaciones, loading, buscarInstalaciones, handleLoading } =
    useInstalacion();

  useEffect(() => {
    handleLoading(true);
    buscarInstalaciones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns: ColumnDefinitionType<Instalacion, keyof Instalacion>[] =
    [
      {
        key: 'nombre',
        header: 'Nombre de Instalación',
      },
      {
        key: 'domicilio',
        header: 'Domicilio',
        cell: (data: Instalacion) => <>{data.domicilio ?? ''}</>,
      },
      {
        key: 'localidad',
        header: 'Localidad',
        cell: (data: Instalacion) => <>{data.localidad ?? ''}</>,
      },
      {
        key: 'telefono',
        header: 'Teléfono',
        cell: (data: Instalacion) => <>{data.telefono ?? ''}</>,
      },
      {
        key: 'id',
        header: 'QR',
        cell: (data: Instalacion) => (
          <Link
            to={'#'}
            title="Código QR"
            onClick={(e) => {
              e.stopPropagation();
              downloadAndOpenQR(`/instalaciones/${data.id}/QRCode`);
            }}
          >
            <i
              className="fa fa-qrcode fa-lg mx-1 text-success"
              aria-hidden="true"
            ></i>
          </Link>
        ),
      },
    ];

  return (
    <Accordion
      id={'accordionInstalacionListado'}
      title="Listado de Instalaciones"
      iconoClass="fa fa-search mr-1"
    >
      <div className="table-responsive ">
        {loading ? (
          <Loading />
        ) : (
          <Table
            data={instalaciones || []}
            columns={columns}
            notResults="No existen instalaciones para el criterio ingresado"
          ></Table>
        )}
      </div>
    </Accordion>
  );
};
